import { ReactNode } from 'react';

export function Field({ label, hint, children, htmlFor }: { label: string; hint?: string; children: ReactNode; htmlFor?: string }) {
  return (
    <label htmlFor={htmlFor} className="flex flex-col gap-1.5">
      <span className="text-xs font-medium text-ink-2">{label}</span>
      {children}
      {hint && <span className="text-[11px] text-ink-4">{hint}</span>}
    </label>
  );
}

const INPUT = 'w-full bg-surface border border-border-2 rounded-md px-2.5 py-1.5 text-sm ' +
  'text-ink hover:border-ink-4 ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus:border-accent ' +
  'disabled:bg-surface-3 transition';

export const Input = (props: React.InputHTMLAttributes<HTMLInputElement>) =>
  <input {...props} className={`${INPUT} ${props.className ?? ''}`}/>;

export const Select = (props: React.SelectHTMLAttributes<HTMLSelectElement>) =>
  <select {...props} className={`${INPUT} pr-7 ${props.className ?? ''}`}/>;

export const Textarea = (props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) =>
  <textarea {...props} className={`${INPUT} resize-none ${props.className ?? ''}`}/>;
